import { gql } from '@apollo/client'
import {
  FRAGMENT_BOUGHT_TOGETHER_VARIANTS,
  FRAGMENT_CART,
  FRAGMENT_CART_SYNC_NOTIFICATIONS,
  FRAGMENT_CART_SYNC_CART_LINES,
} from './fragments'

export const GET_CART = gql`
  query GET_CART {
    cart {
      ...FragmentCart
    }
  }
  ${FRAGMENT_CART}
`

export const GET_CART_NOTIFICATIONS = gql`
  query GET_CART {
    cart {
      ...FragmentNotifications
    }
  }
  ${FRAGMENT_CART_SYNC_NOTIFICATIONS}
`

export const GET_CART_LAYOUT = gql`
  query GET_CART_LAYOUT {
    customer {
      id
      cart {
        ...FragmentboughtTogether
      }
    }
  }
  ${FRAGMENT_BOUGHT_TOGETHER_VARIANTS}
`

export const CUSTOMER_ADD_TO_CART = gql`
  mutation CUSTOMER_ADD_TO_CART(
    $variantId: Int!
    $quantity: Int!
    $cartLineType: CartLineTypeEnum!
  ) {
    cartLinesAdd(
      input: {
        cartLines: [
          {
            variantId: $variantId
            quantity: $quantity
            cartLineType: $cartLineType
          }
        ]
      }
    ) {
			ok
			guestToken
			# guestTokenExpiry
      cart {
        ...FragmentCart
      }
    }
  }
  ${FRAGMENT_CART}
`

export const CUSTOMER_UPDATE_CART_ITEM = gql`
  mutation CUSTOMER_UPDATE_CART_ITEM(
    $variantId: Int!
    $quantity: Int!
    $cartLineType: CartLineTypeEnum!
  ) {
    cartLinesUpdate(
      input: {
        cartLines: {
          variantId: $variantId
          quantity: $quantity
          cartLineType: $cartLineType
        }
      }
    ) {
			ok
			guestToken
			# guestTokenExpiry
      cart {
        ...FragmentCart
      }
    }
  }
  ${FRAGMENT_CART}
`

export const CUSTOMER_DELETE_FROM_CART = gql`
  mutation CUSTOMER_DELETE_FROM_CART($variantId: Int!) {
    cartLinesDelete(input: { cartLines: [{ variantId: $variantId }] }) {
			ok
			guestToken
			# guestTokenExpiry
      cart {
        ...FragmentCart
      }
    }
  }
  ${FRAGMENT_CART}
`

export const CUSTOMER_BULK_ADD_TO_CART = gql`
  mutation CUSTOMER_BULK_ADD_TO_CART($cartLines: [CartLineFieldsInput!]!) {
    cartLinesAdd(input: { cartLines: $cartLines }) {
			ok
			guestToken
			# guestTokenExpiry
      cart {
        ...FragmentCart
      }
    }
  }
  ${FRAGMENT_CART}
`

export const CART_DELIVERY_DATE = gql`
  mutation CART_DELIVERY_DATE($deliveryDate: String!) {
    cartDeliveryDate(input: { deliveryDate: $deliveryDate }) {
      ok
      cart {
        ...FragmentCart
      }
    }
  }
  ${FRAGMENT_CART}
`

export const CART_SYNC_MUTATION = gql`
  mutation CART_SYNC_MUTATION {
    cartSync(input: {}) {
      ok
      checkoutUrl
      cart {
        id
        bigcommerceId
        multipleDeliveryDates
        deliveryDate
        customer {
          bigcommerceId
        }
        ...FragmentNotifications
        ...FragmentCartSyncCartLines
      }
    }
  }
  ${FRAGMENT_CART_SYNC_NOTIFICATIONS}
  ${FRAGMENT_CART_SYNC_CART_LINES}
`


export const CART_CLEAR_MUTATION = gql`
  mutation CART_CLEAR {
		cartClear(input: {}) {
			ok
			cart {
				...FragmentCart
			}
		}
	}
	${FRAGMENT_CART}
`